module.exports = __webpack_public_path__ + "img/1.61083442.png";